export default __webpack_public_path__ + "static/media/A10.81ed438b.png";